module.exports = __webpack_public_path__ + "static/img/div-base-img1.1f7a4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCodePhone/div-base-img1.png
// module id = tb1V
// module chunks = 0